<template>
    <div>
        <div class="order-receipt-header">
            <h1>{{ $t('user.orders') }}</h1>
        </div>
        <div class="order-receipt-content cart">
            
            <v-data-table :headers="headers" :items="orders" class="elevation-3">
                <template v-slot:item.name="{ item }">
                    <div class="p-2">
                        <v-btn x-small @click="showProducts(item)">{{ $t('order.show_product') }}</v-btn>
                    </div>
                </template>
                <template v-slot:item.dateOrder="{ item }">
                    <div class="p-2">
                        <p x-small>{{ item.created_at | moment}}</p>
                    </div>
                </template>

                <template v-slot:item.status="{ item }">
                    <div class="p-2">
                        <p style="background-color: #777777;padding:10px;color: #fff" v-if="item.status == 1">{{ $t('order.statuses.pending') }}</p>
                        <p style="background-color: #163d11;padding:10px;color: #fff" v-if="item.status == 2">{{ $t('order.statuses.completed') }}</p>
                    </div>
                </template>

                <template v-slot:item.total="{ item }">
                    <div class="p-2">
                        <p >$ {{ parseFloat(item.total).toFixed(2) }}</p>
                    </div>
                </template>

                <template v-slot:item.remove="{ item }">
                    <div class="p-2">
                        <v-btn x-small color="primary">{{ $t('order.reorder') }}</v-btn>
                    </div>
                </template>
            </v-data-table>
        </div>

        <v-dialog
            transition="dialog-bottom-transition"
            max-width="900"
            v-model="dialog"
        >
            <template>
            <v-card>
                <v-card-text>
                    <div class="text-h5 pa-3">
                        <v-data-table :headers="headers2" :items="orderProducts" class="elevation-3">
                            <template v-slot:item.name="{ item }">
                                <div class="p-2">
                                    <p>{{ item.product.name }}</p>
                                </div>
                            </template>

                            <template v-slot:item.image="{ item }">
                                <div class="p-2" v-if="item.product.img_url != null && item.product.img_url != ''">
                                    <img :src="item.product.img_url" width="150px" height="140px"/>
                                </div>
                                <div class="p-2" v-else>
                                    <v-img src="../../assets/img/cam-icon.png" max-width="120" alt="Image"/>
                                </div>
                            </template>

                            <template v-slot:item.price="{ item }">
                                <div class="p-2">
                                    $ {{ item.product.price }}
                                </div>
                            </template>

                            <template v-slot:item.quantity="{ item }">
                                <div class="p-2">
                                    <span style="margin-left: 5px; margin-right: 5px;">{{ item.quantity }}</span>
                                </div>
                            </template>
                            <template v-slot:item.total="{ item }">
                                <div class="p-2">
                                    <span style="margin-left: 5px; margin-right: 5px;">$ {{ parseFloat(item.total).toFixed(2) }}</span>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                        @click="dialog = false"
                    >Ok</v-btn>
                </v-card-actions>
            </v-card>
            </template>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters , mapActions} from "vuex";

export default {
    name: 'Navbar',
    data() {
        return {
            headers: [
                { text: "#Commande", value: "id", sortable: false },
                { text: "Liste des achats", value: "name", sortable: false },
                { text: "Date d'achat", value: "dateOrder", sortable: false },
                { text: "Date de livraison prévue", value: "delivery_option", sortable: false },
                { text: "Total de la commande", value: "total", sortable: false },
                { text: "Status", value: "status", sortable: false },
                { text: "Actions", value: "remove", sortable: false },
            ],
            headers2: [
                { text: "Image", value: "image", sortable: false },
                { text: "Name", value: "name", sortable: false },
                { text: "Price", value: "price", sortable: false },
                { text: "Quantity", value: "quantity", sortable: false },
                { text: "Total", value: "total", sortable: false },
            ],
            dialog: false,
            orderProducts: []
        };
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['orders']),
    },
    filters: {
        moment: function (date) {
            return moment(date).format('LLL');
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async showProducts(item) {
            //let u = await this.orderProduct(id)
            this.orderProducts = item.products
            this.dialog = true
        }
    },

    created(){
        let user = JSON.parse(window.localStorage.getItem("userCPF"));
        this.$store.dispatch('fetchOrder', user.id);
    },
    mounted() {
        console.log(this.orders)
    }
}
</script>


<style lang="scss" scoped>

.menu-slogan {
  padding-top: 30px;
}
.cart {
    padding-top: 20px;
    padding-left: 5%;
    padding-right: 5%;
    padding-bottom: 10%;
    margin-top: 50px;
    overflow: hidden;
    #head {
      width: 100%;
      border-bottom: 1px solid #BFBFBF;
      height: 40px;
      display: block;
      h3 {
        display: inline-block;
        line-height: 40px;
        margin: 0;
      }
      #price {
        display: inline-block;
        color: #777777;
        margin-left: 200px;
        line-height: 40px;
      }
      #quantity {
        display: inline-block;
        color: #777777;
        margin-left: 100px;
        line-height: 40px;
      }
      #total {
        display: inline-block;
        color: #777777;
        line-height: 40px;
        float: right;
      }
    }
    h5 {
      font-size: 1.2rem;
      text-align : right;
      color: rgb(6, 6, 77);
      margin-bottom: 10px;
    }

    .cart-actions {
      font-size: 1.2rem;
      text-align : right;
    }
}

.order-receipt {
    background-color: #f9fafb;

    &-header {
        padding-top: 20px;
        background-color: #ffffff;
        height: 100px;
        text-align: center;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-self: center;
        min-width: 100%;
        font-size: 26px;
        font-weight: bold;
    }

    &-content {
        padding: 40px;
        background-color: #f9fafb;
        min-height: 400px;
        text-align: center;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-self: center;
    }
}
</style>